import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { themes } from '../config/themes';

export default function ThemePicker({ selectedTheme, onThemeChange, navigationPosition, onNavigationPositionChange }) {
  const pickerRef = useRef(null);

  const handleThemeChange = (themeId) => {
    onThemeChange(themeId);
    if (pickerRef.current) pickerRef.current.removeAttribute('open');
  };


  const handleNavigationPositionChange = (position) => {
    onNavigationPositionChange(position);
    if (pickerRef.current) pickerRef.current.removeAttribute('open');
  };
  return (
    <details className="top-theme-picker" ref={pickerRef}>
      <summary title="Alterar cor do sistema" aria-label="Alterar cor do sistema">
        <i className="pi pi-palette" />
        <span>Tema</span>
      </summary>
      <div className="top-theme-popover">
        <div className="top-theme-heading">
          <span className="top-theme-icon"><i className="pi pi-palette" /></span>
          <div><strong>Cor do sistema</strong><small>A preferência será salva para o operador.</small></div>
        </div>
        <div className="navigation-position-picker">
          <strong>Posição do menu</strong>
          <div>
            <button type="button" className={navigationPosition === 'top' ? 'is-selected' : ''} onClick={() => handleNavigationPositionChange('top')}><i className="pi pi-window-maximize" /> Topo</button>
            <button type="button" className={navigationPosition === 'side' ? 'is-selected' : ''} onClick={() => handleNavigationPositionChange('side')}><i className="pi pi-align-left" /> Lateral</button>
            <button type="button" className={navigationPosition === 'side-collapsed' ? 'is-selected' : ''} onClick={() => handleNavigationPositionChange('side-collapsed')}><i className="pi pi-bars" /> Recolhida</button>
          </div>
        </div>
        <div className="top-theme-options" role="radiogroup" aria-label="Escolha a cor do sistema">
          {themes.map(theme => (
            <button
              key={theme.id}
              type="button"
              role="radio"
              aria-checked={selectedTheme === theme.id}
              className={selectedTheme === theme.id ? 'is-selected' : ''}
              onClick={() => handleThemeChange(theme.id)}
            >
              <span className="top-theme-swatch" style={{ backgroundColor: theme.color }}><i className="pi pi-check" /></span>
              <span><strong>{theme.name}</strong><small>{theme.description}</small></span>
            </button>
          ))}
        </div>
      </div>
    </details>
  );
}

ThemePicker.propTypes = {
  selectedTheme: PropTypes.string.isRequired,
  onThemeChange: PropTypes.func.isRequired,
  navigationPosition: PropTypes.oneOf(['top', 'side', 'side-collapsed']),
  onNavigationPositionChange: PropTypes.func,
};

ThemePicker.defaultProps = {
  navigationPosition: 'top',
  onNavigationPositionChange: () => {},
};


